import { getAuthBackgroundCountry } from '@xarvio/frontend-core-components/components/PageLayoutAuth/PageLayoutAuthBg/authBackground';
import {
  getAppBasePath,
  withAppBasePath,
} from '@xarvio/frontend-core-platform/lib/basePath';

import { isLoginRoute } from './authRouteUtils';

export const preloadLoginBackground = (pathname: string) => {
  const basePath = getAppBasePath();
  const routePathname = pathname.startsWith(basePath)
    ? pathname.slice(basePath.length)
    : pathname;

  if (!isLoginRoute(routePathname)) {
    return;
  }

  const country = routePathname.split('/')[1];
  const link = document.createElement('link');

  link.rel = 'preload';
  link.as = 'image';
  link.type = 'image/avif';
  link.fetchPriority = 'high';
  link.href = withAppBasePath(
    `/assets/auth/bg/${getAuthBackgroundCountry(country)}.avif`,
  );

  document.head.append(link);
};
